import React from 'react';

const LineAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg style={{ width: '100%', display: 'block' }} viewBox="0 0 88 87" {...props}>
    <g fillRule="nonzero" fill="none">
      <rect fill={props.color || '#1F77E0'} x={0.93} y={0.4} width={86.6} height={86.6} rx={43.3} />
      <g fill="#FFF">
        <path opacity={0.5} d="M44.23 16.64L20.8 30.17v27.06l23.43 13.53 23.44-13.53V30.17z" />
        <path
          opacity={0.5}
          d="M55.95 23.4v.01-.01l-11.72-6.76-11.72 6.76V64l11.72 6.76L55.95 64v-.01.01l11.72-6.77V30.17z"
        />
        <path
          opacity={0.5}
          d="M55.95 23.4v.01-.01l-11.72-6.76v54.12L55.95 64v-.01.01l11.72-6.77V30.17z"
        />
        <path opacity={0.9} d="M55.95 64l11.72-6.77V30.17L55.95 23.4z" />
      </g>
    </g>
  </svg>
);

export default LineAnnotationIcon;
